function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.282"
      height="24.735"
      viewBox="0 0 18.282 24.735">
      <g data-name="Privacy Policiy" transform="translate(-242.398 181.6)">
        <g data-name="Group 2649" transform="translate(242.398 -181.6)">
          <path
            fill="none"
            d="M514.9-138.4v2.055h1.892z"
            data-name="Path 5637"
            transform="translate(-500.58 140.67)"></path>
          <path
            fill={props.fill}
            d="M256.36-181.6s-11.829 0-12.691.021a1.543 1.543 0 00-1.272 1.5v21.7a1.6 1.6 0 001.519 1.519h15.244a1.562 1.562 0 001.519-1.519v-18.529zm.357 4.325v-2.055l1.892 2.055z"
            data-name="Path 5638"
            transform="translate(-242.398 181.6)"></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
